import { useEffect, useState } from 'react';

import { fetchCheckoutConfigsForCountry } from '@/lib/configuration/api';
import { WITHDRAWAL_ENABLED } from '@/lib/const';
import { getCountryForChannel } from '@/lib/regions';
import { isWithdrawalScopeFromCheckoutConfig } from '@/lib/withdrawal/withdrawalScopeFromCheckoutConfig';

export function useOrderWithdrawalScope(orderChannelSlug: string | undefined) {
  const [isScopeLoading, setIsScopeLoading] = useState(false);
  const [isOrderInWithdrawalScope, setIsOrderInWithdrawalScope] =
    useState(false);

  useEffect(() => {
    if (!WITHDRAWAL_ENABLED || !orderChannelSlug) {
      setIsOrderInWithdrawalScope(false);
      setIsScopeLoading(false);
      return;
    }

    let cancelled = false;
    const countryCode = getCountryForChannel(orderChannelSlug).code;

    async function loadScope() {
      setIsScopeLoading(true);
      try {
        const configs = await fetchCheckoutConfigsForCountry(countryCode);
        if (cancelled) {
          return;
        }
        setIsOrderInWithdrawalScope(
          isWithdrawalScopeFromCheckoutConfig(configs, orderChannelSlug),
        );
      } catch {
        if (!cancelled) {
          setIsOrderInWithdrawalScope(false);
        }
      } finally {
        if (!cancelled) {
          setIsScopeLoading(false);
        }
      }
    }

    loadScope();

    return () => {
      cancelled = true;
    };
  }, [orderChannelSlug]);

  return { isOrderInWithdrawalScope, isScopeLoading };
}
